var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMoneyWithDraw = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 22 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21 0H1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-9h3a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1ZM6 18v-2a2 2 0 0 1 2 2H6Zm10 0h-2a2 2 0 0 1 2-2v2Zm0-4a4 4 0 0 0-4 4h-2a4 4 0 0 0-4-4V6h10v8Zm4-6h-2V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v3H2V2h18v6Zm-9 5a3 3 0 1 0 0-5.999A3 3 0 0 0 11 13Zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z",
  fill: "currentColor"
})));

export default SvgMoneyWithDraw;